import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NETWORK } from '~/contexts/network/router/routes'

const NETWORK_ROUTE: RouteRecordRaw = {
  name: ROUTE_NETWORK.ACTIVITY,
  path: '',
  component: () => import('~/contexts/network/pages/index.vue'),
  meta: {
    name: 'network-activity',
  },
}

const NETWORK_INVITATIONS_ROUTE: RouteRecordRaw = {
  name: ROUTE_NETWORK.INVITATIONS,
  path: 'invitations',
  component: () => import('~/contexts/network/pages/invitations.vue'),
  meta: {
    name: 'network-invitations',
  },
}

const NETWORK_USER_INDEX_ROUTE: RouteRecordRaw = {
  name: ROUTE_NETWORK.USER_HOME,
  path: '',
  redirect: { name: ROUTE_NETWORK.USER_ACTIVITY },
}

const NETWORK_USER_ACTIVITY_ROUTE: RouteRecordRaw = {
  name: ROUTE_NETWORK.USER_ACTIVITY,
  path: 'activity',
  component: () => import('~/contexts/network/pages/user/[thread_id]/index/activity.vue'),
  meta: {
    name: 'network-user-activity',
  },
}

const NETWORK_USER_NETWORK_ROUTE: RouteRecordRaw = {
  name: ROUTE_NETWORK.USER_NETWORK,
  path: 'network',
  component: () => import('~/contexts/network/pages/user/[thread_id]/index/network.vue'),
  meta: {
    name: 'network-user-network',
  },
}

const NETWORK_USER_PROFILE_ROUTE: RouteRecordRaw = {
  name: ROUTE_NETWORK.USER_PROFILE,
  path: 'profile',
  component: () => import('~/contexts/network/pages/user/[thread_id]/index/profile.vue'),
  meta: {
    name: 'network-user-profile',
  },
}

const NETWORK_USER_ROUTES: RouteRecordRaw = {
  path: 'user/:thread_id',
  component: () => import('~/contexts/network/pages/user/[thread_id]/index.vue'),
  children: [
    NETWORK_USER_INDEX_ROUTE,
    NETWORK_USER_ACTIVITY_ROUTE,
    NETWORK_USER_NETWORK_ROUTE,
    NETWORK_USER_PROFILE_ROUTE,
  ],
  meta: {
    name: 'network-user',
  },
}

/** Register all community routes as child of "/community" namespace */
export function getRoutes() {
  return [
    NETWORK_ROUTE,
    NETWORK_INVITATIONS_ROUTE,
    NETWORK_USER_ROUTES,
  ]
}
